// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__qfLQ-","insightsList":"newBusinessInsightsMenu_insightsList__1VVg-","active":"newBusinessInsightsMenu_active__3ewhF"};